import type { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'com.bharatlaw.app',
  appName: 'bharatlaw',
  webDir: 'www'
};

export default config;
